<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Standard Outstanding Report </strong>
        </v-toolbar-title>
      </v-toolbar>

      <v-row dense justify="center">
        <v-col sm="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="ay" :items="ay_list" item-text="ay" item-value="id"
            label="Academic Year" outlined @click="clear()" persistent-hint
            hint="Please Select Standard"></v-autocomplete>
        </v-col>
        <v-col sm="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard"
            item-value="id" label="Standard" outlined @click="clear()" persistent-hint multiple
            hint="Please Select Standard"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" sm="3">
          <v-icon color="error">*</v-icon>
          <v-autocomplete color="#0F2027" dense rounded required v-model="status" @change="clear()" :items="status_list"
            item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
        </v-col>
        <v-col sm="3">
          <v-btn rounded class="button mt-6" @click="getAllReport()" :loading="loader">Fetch</v-btn>
        </v-col>
      </v-row>
      <v-col cols="12" sm="12" md="12" v-if="learner_info != ''" class="">
        <v-toolbar v-if="failed_record_list != ''" dense class="toolbar" flat color="white">
          <v-toolbar-title>Failed Records</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <download-excel class="mr-2 pb-3 pt-2" :data="failed_record_list" :fields="import_table_fields"
            worksheet="Failed_Student_List" name="Failed_student_list.xls">
            <v-btn outlined rounded color="white">
              <v-icon>mdi-file-excel</v-icon> Export
            </v-btn>
          </download-excel>
        </v-toolbar>
        <br />
        <v-data-table v-if="failed_record_list != ''" dense :headers="status_headers" :items="failed_record_list"
          sort-by class="elevation-1 mytable" :search="search"></v-data-table>
        <!-- <v-col sm="3">
                    <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col> -->
        <v-row dense>
          <v-col sm="6" md="6">
            <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'standardoutstandingreport')"
              :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
          </v-col>
          <!-- search code shiv -->
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="search1" append-icon="mdi-magnify"
              label="Search by Student name or by Registration Number" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
        <div id="my-table-id">
          <div class="scroll">
            <v-simple-table dense class="elevation-1" fixed-header height="500px">
              <thead>
                <tr>
                  <th class="">Sr. No.</th>
                  <th class="">Registration No.</th>
                  <th class="">Name</th>
                  <th class="">Mobile No.</th>
                  <th class="">Quota</th>
                  <th class="">Academic Year</th>
                  <th class="">Standard</th>
                  <th class="">Division</th>
                  <th class="">Admission Year</th>
                  <th class="" colspan="3" v-for="(header, index) in ay_header" :key="index">
                    <center>{{ header }}</center>
                  </th>
                  <th class="">Total Fee Paid</th>
                  <th class="">Total Fee</th>
                  <th class="">Total Fee Remaining</th>
                </tr>
              </thead>
              <tbody style="overflow-y: scroll">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th v-for="(header, index) in ay_header.length * 3" :key="index">
                    <span v-if="header % 3 == 0"> Balance Outstanding </span>
                    <span v-else-if="header % 3 == 1"> Paid Outstanding </span>
                    <span v-else> Total Outstanding </span>
                  </th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
                <!-- <tr v-for="s in learner_info" :key="s.id"> -->
                <tr v-for="s in filteredItems" :key="s.id">
                  <td>{{ s.sr_no }}</td>
                  <td>{{ s.reg_no }}</td>
                  <td>{{ s.name }}</td>
                  <td>{{ s.primary_contact_number }}</td>
                  <td>{{ s.quota }}</td>
                  <td>{{ s.academicyear }}</td>
                  <td>{{ s.standard }}</td>
                  <td>{{ s.div }}</td>
                  <td>{{ s.learner_addmission_year }}</td>
                  <td v-for="(header, index) in s.out_amt" :key="index">
                    <span v-if="header == 'NA'" class="text-color">
                      {{ header }}
                    </span>
                    <span v-else>
                      {{ header }}
                    </span>
                  </td>
                  <td>{{ s.final_total_paid }}</td>
                  <td>{{ s.final_total }}</td>
                  <td>{{ s.final_total_reamining }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </div>
      </v-col>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      loader: false,
      color: "",
      snackbar: false,
      // extraBreadcrumbItems: [


      // ],
      // breadcrumbClass: "breadcrumb-style1",
      search: null,
      snackbar_msg: null,
      std: [],
      header: null,
      standard_list: null,
      show: false,
      learner_info: [],
      ay_header: [],
      failed_record_list: [],
      ay_list: [],
      ay: null,
      search1: "",
      import_table_fields: {
        "Registration No.": "reg_no",
        Reason: "reason",
      },
      status_headers: [
        {
          text: "Registration No.",
          value: "reg_no",
        },
        {
          text: "Reason",
          align: "left",
          sortable: true,
          value: "reason",
        },
      ],
      status_list: [
        { name: "Active", id: "0" },
        { name: "Temporary Inactive", id: "1" },
        { name: "Permanent Inactive", id: "2" },
      ],
      status: null,
    };
  },
  computed: {
    filteredItems() {
      return this.learner_info.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(this.search1.toLowerCase()) > -1 ||
          item.reg_no.toLowerCase().indexOf(this.search1.toLowerCase()) > -1
        );
      });
    },
  },
  methods: {
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text =
        tab_text +
        "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text =
        tab_text +
        "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text =
        tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
        $(elem).remove();
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName =
        name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

      //Save the file
      // var blob = new Blob([tab_text], {
      //   type: "application/vnd.ms-excel;charset=utf-8",
      // });
      // window.saveAs(blob, fileName);
      const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    ExportToExcel() {
      var htmltable = document.getElementById("my-table-id");
      var html = htmltable.outerHTML;
      window.open("data:application/vnd.ms-excel," + encodeURIComponent(html));
    },
    clear() {
      this.learner_info = [];
    },

    getAllReport() {
      this.loader = true;
      const data = {
        std: this.std,
        ay: this.ay,
        status: this.status,
      };
      axios
        .post("/OutstandingFees/getStandardOutstandingReport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.loader = false;
            this.learner_info = res.data.learner_info;
            this.ay_header = res.data.ay_header;
            this.failed_record_list = res.data.failed_record_list;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          this.loader = false;
          this.dataTable = $("#admitted-student-report").DataTable({
            colReorder: true,
            dom: "Bfrtip",
            buttons: ["csvHtml5", "excelHtml5"],
          });
          this.dataTable = $("#admitted-student").DataTable({
            colReorder: true,
            dom: "Bfrtip",
            buttons: ["csvHtml5", "excelHtml5"],
          });
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/OutstandingFees/getStandard")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.standard_list = res.data.user_wise_standard_list;
            this.ay_list = res.data.ay_list;
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>
<style scoped>
.scroll {
  overflow-x: scroll;
}
.text-color {
  font-weight: bold;
  color: red;
  font-size: small;
}
tr,
td,
th {
  border: 1px solid #ccc;
  text-align: center;
  font-size: small;
}
tr,
tbody {
  border-bottom: 1px solid #ccc;
  border: 1px solid #ccc;
  font-size: small;
}
td {
  margin: 0.3rem !important;
  padding: 0.4rem !important;
  font-size: small;
}
@media (min-width: 320px) {
  td,
  th {
    display: table-cell !important;
    font-size: small;
  }
  td + td,
  th + th {
    width: auto;
    font-size: small;
  }
}
v-simple-table {
  white-space: nowrap !important;
  text-align: center;
  font-size: small;
}
.mytable /deep/ thead th {
  background: #0f2027 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #2c5364,
    #203a43,
    #0f2027
  ) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background-color: #0f2027 !important;
  color: white !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: center;
}
.dt-button {
  font-size: small;
  font-weight: bold;
}
.dt-button.buttons-print::before {
  content: "\F42A";
  margin-right: 8px;
  margin-top: 8px;
  font-size: small;
}
.dt-button.buttons-excel::before {
  content: "\F21B";
  margin-right: 8px;
  margin-top: 8px;
  font-size: small;
}
.dt-button.buttons-csv::before {
  content: "\FEC2";
  margin-right: 8px;
  margin-top: 8px;
  font-size: small;
}
button.dt-button:hover:not(.disabled),
div.dt-button:hover:not(.disabled),
a.dt-button:hover:not(.disabled) {
  border-color: #ff9800;
  color: #ff9800;
}
.dataTables_wrapper .dataTables_filter input[type="search"] {
  border-radius: 2px;
  border: 1px solid #cdcdcd;
  cursor: auto;
  white-space: nowrap !important;
}
</style>
